/*
 * Merch Control - flying logo load-in (client note 2).
 * Plays once per browser session, skips entirely under prefers-reduced-motion,
 * and never blocks interaction (pure CSS opacity/transform on the existing
 * header logo image - no overlay, no pointer-events changes).
 */
(function () {
  var SESSION_KEY = 'mcLogoIntroPlayed';

  var alreadyPlayed = false;
  try {
    alreadyPlayed = !!sessionStorage.getItem(SESSION_KEY);
  } catch (e) {
    // sessionStorage unavailable (privacy mode, etc.) - skip the animation silently,
    // never let this block header rendering.
    return;
  }
  if (alreadyPlayed) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {}
    return;
  }

  function markPlayed() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {}
  }

  function play() {
    var logoImg = document.querySelector('.header-logo__image');
    if (!logoImg) return false;
    logoImg.classList.add('mc-logo-fly-in');
    markPlayed();
    return true;
  }

  function waitForLogo() {
    // Guard: the header can hydrate/replace its markup after this deferred
    // script first runs (see @theme/section-hydration in
    // sections/header.liquid), so a single querySelector at parse time
    // isn't reliable if the logo image lands late. Watch for it to appear,
    // capped at 5s so the observer never runs forever.
    var observer = new MutationObserver(function () {
      if (play()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 5000);
  }

  function attemptPlay() {
    if (play()) return;
    waitForLogo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attemptPlay);
  } else {
    attemptPlay();
  }
})();
